import React,{useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetSearchData } from '../Redux/Slice/DataSlice'

const SearchBar = () => {
  const {SearchQuery,Cardetails}=useSelector((state)=>state.CarData)
  const Dispatch=useDispatch()
  const [searchData, setsearchData] = useState({
    carName:SearchQuery.carName,
    Category:SearchQuery.Category,
    Brand:SearchQuery.Brand,
    Price:SearchQuery.Price  
  })

  const handleclick=(event)=>{
    setsearchData((old)=>{
      return{
        ...old,[event.target.name]:event.target.value
      }
    })
  }

  const SearchButton=()=>{
    Dispatch(GetSearchData(searchData))
   
  }

  const {Brands,Categories}=useSelector((state)=>state.CarData)
  return (
    
    <div class="w-[100%] text-center h-[100%] flex justify-center items-center ">

      <div class="mt-2 flex flex-col space-y-3 sm:-mx-2 sm:flex-row sm:justify-center sm:space-y-0 mb-2">
        <input id="email" name='carName' list="Cars" value={searchData.carName}  onChange={handleclick}  type="search" class="rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2 mx-2" placeholder="Search Cars" />
        <datalist id="Cars">
        {
          Cardetails && Cardetails.map((x)=>{
            return(
              <option value={x.Name}>{x.Name}</option>
            )
          })
        }  
            </datalist>




        <div class="flex flex-row m-2 ">
                        <div class="m-1">
                        <select name='Category' value={searchData.Category} onChange={handleclick} class="rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 ">
                                <option selected  className='bg-black '>Vehical Types</option>
                                {
                                  Categories.map((x)=>{
                                    return(
                                    <option value={x.Categories} className='bg-black  text-white'>{x.Categories}</option>
                                    )

                                  })
                                }
                               
                            </select>
                        </div>
                     
                        <div class="m-1">
                        <select name='Brand' value={searchData.Brand} onChange={handleclick} class="rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2">
                                <option selected className='p-1 bg-black'>Brand</option>
                                {
                                   Brands.map((x)=>{
                                    return(
                                    <option value={x.Brand} className='bg-black '>{x.Brand}</option>
                                    )

                                  })
                                }
                            </select>
                        </div>

                        {/* <div class="m-1">
                        <select name='Price' value={searchData.Price} onChange={handleclick} class="rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2">
                                <option  className='p-1 bg-black'>Price</option>
                                <option  className='p-1 bg-black'>1-5 Lakh </option>
                                <option className='p-1 bg-black'>5-10 Lakhs</option>
                                <option className='p-1 bg-black'>10-15 Lakhs</option>
                                <option className='p-1 bg-black'>15-20 Lakhs</option>
                                <option className='p-1 bg-black'>20-25 Lakhs</option>
                                <option className='p-1 bg-black'>25-30 Lakhs</option>
                                <option className='p-1 bg-black'>30-35 Lakhs</option>
                                <option className='p-1 bg-black'>35-40 Lakhs</option>
                                <option className='p-1 bg-black'>40 Lakhs * above</option> 
                            </select>
                        </div> */}
                        </div>

                        

        <button class=" transform rounded-md bg-green-500 sm:px-8 w-[95%] py-2 text-sm font-medium capitalize tracking-wide text-white transition-colors duration-200 hover:bg-blue-600 focus:bg-blue-600 focus:outline-none sm:mx-2 mx-2 " onClick={SearchButton}>Search</button>

      </div>
    </div>


 
  )
}

export default SearchBar